import React, { useState, useEffect, useRef } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import NewButton from '../Buttons/NewButton';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'; // Import dayjs
import 'dayjs/locale/sv';
import { fixDate } from '../../helpers/helperFunctions';

const AlcolockModal = ({ show, data, type, onClose, save }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [date, setDate] = useState(dayjs().add(1, 'day'))
    const [engineBlock, setEngineBlock] = useState(null)
    const [override, setOverride] = useState()
    const [openDate, setOpenDate] = useState(false)

    useEffect(() => {
        if(data && type ){
            setEngineBlock(data?.engineblock)
            setOverride(data?.override)
        }
    }, [type, data])

    
    const handleClose = () => {
        onClose()
        setEngineBlock()
        setOverride()
      //  setShow(false)
    }



    const handleSave = (type) => {
        let data = {}
        switch(type){
            case "engineblock": 
                data = {engineblock: engineBlock?.status}
                break;
            case "override":
                data = {override: date.format("YYYY-MM-DD")}
                break;
            default: data = {}
        }
        save(data)
    }

    const resetEngine = () => {
        let data = {engineblock: !engineBlock?.newmode}
        save(data)
    }

    const resetOverride = () => {
        let data = {override: "cancel"}
        save(data)
    }

    const toggleEngineBlock = () => {
        setEngineBlock(prev => ({
            ...prev,
            status: !prev.status
        }));
    };

    const overrideContent = () => {
            const blocked = engineBlock?.pending || engineBlock?.status || override?.pending?.active

        return(
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="ms-2">{t("settings.override")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                {blocked
                    ? <p className="grey-blue py-3">{t("settings.clear_mode_override")}</p>
                    : <p className="grey-blue py-3">{t("devices.override_sub")}</p>
                }

                <div className="d-flex flex-column align-content-center">
                    <div className="d-flex border-12 p-3 justify-content-center w-100 bg-light-grey mb-3">
                        <div className="d-flex flex-column">
                            <h4 className="bold text-center">{override?.current?.active ? t("devices.enabled") : t("devices.disabled")}</h4>
                            <p className="dark-grey text-center">{t("devices.current_status")}</p>
                        </div>
                        {(override?.pending?.active && !override?.current?.active) &&
                        <>
                        <img src={icons.chevron_right} className="grey-blue-icon mx-3" alt="" />
                        <div className="d-flex flex-column">
                            <h4 className="bold text-center">{override?.pending?.active ? t("devices.enabled") : t("devices.disabled")}</h4>
                            <p className="dark-grey text-center">{t("devices.pending_status")}</p>
                        </div>
                        </>
                        }
                    </div>
                    
                    {(override?.current?.active || override?.pending?.active) &&
                    <div className="d-flex border-12 p-3 justify-content-center w-100 bg-light-grey mb-3">
                        {override?.current?.active &&
                        <div className="d-flex flex-column justify-content-center">
                            <h4 className="bold text-center">{override?.current?.overrideuntil ? fixDate(override?.current?.overrideuntil, true) : t("devices.no_expiration")}</h4>
                            <p className="dark-grey text-center">{t("devices.current_end_date")}</p>
                        </div>
                        }
                        {override?.current?.active && override?.pending?.active && <img src={icons.chevron_right} className="grey-blue-icon mx-3" alt="" />}
                        {(override?.pending?.active) &&
                        <>
                        <div className="d-flex flex-column">
                            <h4 className="bold text-center">{override?.pending?.overrideuntil ? fixDate(override?.pending?.overrideuntil, true) : t("devices.no_expiration")}</h4>
                            <p className="dark-grey text-center">{t("devices.pending_end_date")}</p>
                        </div>
                        </>
                        }
                    </div>
                    }
                </div>
                {override?.pending?.active &&
                    <div className="d-flex justify-content-center align-items-center green cursor-pointer pb-3" onClick={() => resetOverride()}>
                        <p className="gradient">{t("settings.reset_pending")}</p>
                        <img className="size_15 ms-2 primary-icon" src={icons.reset_arrow} alt="..." /> 
                    </div>
                }                
                <p className="mb-1 bold">{t("settings.change_date")}</p>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='sv'>
                    <DatePicker
                        open={openDate}
                        onClose={() => setOpenDate(false)}
                        // ampm={false}
                        value={date}
                        onChange={(newValue) => setDate(newValue)}
                        minDate={dayjs()}
                        className="date_label me-1 bg-light-grey p-3 border-12 justify-content-between cursor-pointer w-100 disabled"
                        // format="DD/MM HH:mm" 
                        slotProps={{
                            openPickerButton: { disableRipple: true },
                            textField: {
                                onClick: () => setOpenDate(true),
                                readOnly: true,
                                className:
                                    "date_label ms-1 bg-light-grey p-3 border-12 justify-content-between cursor-pointer",
                            },
                        }}
                        // slots={{ openPickerIcon: () => null }}
                    />
                </LocalizationProvider>
                

                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className={`bg-gradient rounded24 w-100 white ms-2 p-3 body bold ${blocked ? "disabled" : ""}`}>{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const engineBlockContent = () => {
        const blocked = engineBlock?.pending || override?.current?.active || override?.pending?.active
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.battery_settings} alt=""/> */}
                        <h3 className="">{t("settings.engine_block")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                </div>
                    {blocked
                        ? <p className="grey-blue py-3">{t("settings.clear_mode_engineblock")}</p>
                        : <p className="grey-blue py-3">{t("settings.engine_block_sub")}</p>
                    }
                {engineBlock?.pending &&
                    <div className="d-flex justify-content-center align-items-center green cursor-pointer pb-3" onClick={() => resetEngine()}>
                        <p className="gradient">{t("settings.reset_pending")}</p>
                        <img className="size_15 ms-2" src={icons.reset_arrow} alt="..." /> 
                    </div>
                }
                <div className={`d-flex justify-content-between bg-light-grey align-items-center p-3 rounded24`}>
                    <h4 className="regular">{t("settings.engineblock")}</h4>
                    <div className="form-check form-switch">
                        <input 
                            className="form-check-input" 
                            disabled={blocked} 
                            onChange={() => toggleEngineBlock()} 
                            type="checkbox" 
                            role="switch" 
                            id="flexSwitchCheckDefault" 
                            checked={engineBlock?.pending ? engineBlock?.newmode : engineBlock?.status ?? false}/>
                    </div>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => onClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className={`bg-gradient rounded24 w-100 white ms-2 p-3 body bold ${blocked ? "disabled" : ""}`}>{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }


    const typeRender = () => {
        switch(type){
            case "engineblock": return engineBlockContent()
            case "override": return overrideContent()
            default: return null
        }
    }
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                <div className="w-100 h-100">
                    {typeRender()}
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default AlcolockModal;